module.exports = __webpack_public_path__ + "img/customer-support.ab3311e3.png";